import React from 'react';
import PropTypes from 'prop-types';
import { Line, Circle } from 'rc-progress';
import { Progress as AntProgress } from 'antd';
/**
 * 文件上传模块
 */
export default function Progress({
  circle,
  width,
  strokeWidth,
  trailWidth,
  height,
  style,
  ...props
}) {
  if (circle) {
    return (
      <Circle
        {...props}
        strokeWidth={strokeWidth || 8}
        trailWidth={trailWidth || 8}
        style={{
          width: width || '50px',
          height: height || width || '50px',
          ...style
        }}
      ></Circle>
    );
  }
  return (
    <AntProgress
      {...props}
      typr="line"
      strokeWidth={strokeWidth || 1}
      trailWidth={0}
      showInfo={false}
      style={{
        width: width || '100%',
        height: height || 5,
        ...style
      }}
    ></AntProgress>
  );
}

Progress.defaultProps = {
  strokeColor: '#62B929',
  style: {}
};
Progress.propTypes = {
  /** 圆形进度条 */
  circle: PropTypes.bool,
  /** 进度条stroke的高度 */
  strokeWidth: PropTypes.number,
  /** 进度条颜色 */
  strokeColor: PropTypes.string,
  /** 进度, 百分进制 */
  percent: PropTypes.number,
  /** 进度条样式 */
  style: PropTypes.object,
  /** 进度条的宽度 */
  width: PropTypes.number,
  /** 进度条的高度 */
  height: PropTypes.number
};
